<template>
  <!-- Dashboard Box -->
  <div class="col-xl-12">
    <div id="test1" class="dashboard-box">
      <!-- Headline -->
      <div class="headline">
        <h3>
          <i class="icon-material-outline-lock"></i>
          User Location
        </h3>
      </div>

      <div class="content with-padding padding-bottom-10">
        <div class="row">
          <div class="col-xl-4">
            <div class="submit-field">
              <h5>
                Country
                <i
                  class="help-icon"
                  data-tippy-placement="right"
                  title="Update your country"
                ></i>
              </h5>

              <div class="input-with-icon">
                <div class="select__custom">
                  <select title="Select Country">
                    <option :value="null" selected disabled hidden>
                      Select option
                    </option>
                    <option> </option>
                  </select>
                </div>
                <i class="icon-feather-chevron-down"></i>
              </div>
            </div>
          </div>
          <div class="col-xl-4">
            <div class="submit-field">
              <h5>
                Region
                <i
                  class="help-icon"
                  data-tippy-placement="right"
                  title="Update your region"
                ></i>
              </h5>

              <div class="input-with-icon">
                <div class="select__custom">
                  <select title="Select Region">
                    <option :value="null" selected disabled hidden>
                      Select option
                    </option>
                    <option> </option>
                  </select>
                </div>
                <i class="icon-feather-chevron-down"></i>
              </div>
            </div>
          </div>
          <div class="col-xl-4">
            <div class="submit-field">
              <h5>
                City
                <i
                  class="help-icon"
                  data-tippy-placement="right"
                  title="Update your city"
                ></i>
              </h5>

              <div class="input-with-icon">
                <div class="select__custom">
                  <select title="Select Project Model">
                    <option :value="null" selected disabled hidden>
                      Select option
                    </option>
                    <option> </option>
                  </select>
                </div>
                <i class="icon-feather-chevron-down"></i>
              </div>
            </div>
          </div>

          <div class="col-xl-12">
            <a
              href="#"
              class="button ripple-effect big"
              @click="updateUserLocation()"
              ><i class="icon-material-outline-lock mr-1"></i>
              Update User Skills
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

export default {
  name: "UserLocation",
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {
    updateUserLocation() {},
  },
};
</script>

<style scoped></style>
